import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import styled, { ThemeProvider } from 'styled-components/macro';

import { useDataStore } from 'state/DataStore';
import { createTheme } from 'styles/styled-theme';
import GlobalStyles from 'styles/styled-global';
import { flexCenter } from 'styles/styled-mixins';

import { SyncProvider } from 'services/sync/SyncContext';

import AppLoading from './AppLoading';
import FadeInOutTransition from 'components/transitions/FadeInOutTransition';
import Screensaver from 'components/Screensaver';
import Popup from 'components/Popup';
import Shortlist from 'components/Shortlist';

import Body from './Body';
import NavBar from './NavBar';


const App = observer(() => {
    const [ forcedLoading, setForcedLoading ] = useState(true);
    const dataStore = useDataStore();
    const { loaded, shortlistStore } = dataStore;
    
    useEffect(() => {
        const forcedLoadingTimeout = setTimeout(() => setForcedLoading(false), 4200);
        
        return () => clearTimeout(forcedLoadingTimeout);
    }, []);
    
    useEffect(() => {
        if (!loaded) return;
        
        const fonts_url = dataStore.getSetting('style_settings', 'fonts_url');
        
        if (fonts_url) {
            const fontsLink = document.createElement('link');
            
            fontsLink.type = 'text/css';
            fontsLink.rel = 'stylesheet';
            fontsLink.href = fonts_url;
            
            document.head.appendChild(fontsLink);
            
            return () => document.head.removeChild(fontsLink);
        }
    }, [ loaded, dataStore ]);

    return (
        <ThemeProvider theme={createTheme()}>
            <SyncProvider>
                <Container>
                    <Inner>
                        {loaded && (
                            <AppPage>
                                <Body/>
                                <NavBar/>
                            </AppPage>
                        )}

                        <FadeInOutTransition in={(forcedLoading || !loaded)} speed="slow">
                            <AppLoading/>
                        </FadeInOutTransition>
                    </Inner>
                </Container>

                <Popup
                    isOpen={shortlistStore.isPopupOpen}
                    onClose={() => shortlistStore.closePopup()}
                    fullScreen={false}
                    closeButtonInside={true}
                >
                    <Shortlist />
                </Popup>

                <GlobalStyles/>

                {loaded && (
                    <Screensaver />
                )}

            </SyncProvider>
        </ThemeProvider>
    );
});


export default App;


const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
`;

const Inner = styled.div`
    width: 100%;
    height: 100%;
`;

const AppPage = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	z-index: 1;
	
	${flexCenter};
	flex-direction: column;
	
	background-color: ${props => props.theme.app_background};
`;
